module.exports = __webpack_public_path__ + "img/KN.ad086c55.svg";